<template>
  <div class="status-incident-history">
    <StatusItemGroup :items="content" />
  </div>
</template>

<script>
import StatusItemGroup from '@/components/status-item/status-item-group';

export default {
  name: 'StatusHistoryIncidentItem',
  components: { StatusItemGroup },
  props: {
    content: {
      type: Array,
      required: true,
      validator: arr => arr.length > 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'website-design-system/src/foundation/tokens/variables';

.status-incident-history {
  &--tag {
    margin-left: - calc($spacing-24 + $spacing-12);
  }
}
</style>
